// extracted by mini-css-extract-plugin
export default {"checkbox":"_3V-ZV","align-items-center":"_3eKVG","alignItemsCenter":"_3eKVG","label":"_1AnP2"};